import type { FC, ReactNode } from "react";
import { createContext, useMemo } from "react";

import { useStrictContext } from "./useStrictContext";

// eslint-disable-next-line react-refresh/only-export-components
export const domainsSettings: { [domain: string]: DomainSettings } = {
  "jack-check.com": {
    logoHref: "https://jack-pok.com/",
    hideMenu: true,
  },
};

export type DomainSettings = {
  logoHref?: string;
  hideMenu?: boolean;
};

export type PageInfoContext = {
  url: URL;
  domainSettings: DomainSettings | undefined;
};

const pageInfoContext = createContext<PageInfoContext | null>(null);
pageInfoContext.displayName = "pageInfo";

export const PageInfoProvider: FC<{
  children?: ReactNode;
  url: URL;
  domainSettings?: DomainSettings;
}> = (props) => {
  const { url, domainSettings, children } = props;

  const pageInfoContextValue = useMemo(
    () => ({
      url,
      domainSettings,
    }),
    [url, domainSettings],
  );

  return (
    <pageInfoContext.Provider
      value={pageInfoContextValue}
      children={children}
    />
  );
};

// eslint-disable-next-line react-refresh/only-export-components
export const usePageInfoContext = (): PageInfoContext => {
  return useStrictContext(pageInfoContext);
};
